<div class="relative flex flex-col w-full h-full">
    <div class="flex flex-row justify-between flex-auto items-center sm:items-center">
        <div class="text-2xl leading-6 font-bold p-4 flex items-center break-all">
            {{ data.title }}
        </div>
        <div class="p-4">
            <button (click)="onCancel()" mat-icon-button>
                <mat-icon class="text-secondary" [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
            </button>
        </div>
    </div>

    <div class="flex-auto overflow-auto px-6 pt-2 pb-6">
        <p class="m-0 text-[15px] leading-relaxed text-gray-600 dark:text-gray-300 font-medium">
            {{ data.message }}
        </p>
    </div>

    <div class="flex items-center justify-center sm:justify-between px-6 py-4 bg-gray-100 dark:bg-black dark:bg-opacity-10 gap-2 flex-wrap">
        <div></div>
        <div></div>
        <div class="flex items-center gap-2 flex-wrap">
            <button (click)="onCancel()" mat-stroked-button [color]="'primary'">{{ data.cancelText || 'Fechar' }}</button>
            <button (click)="onConfirm()" mat-flat-button [color]="'primary'">{{ data.confirmText || 'Confirmar' }}</button>
        </div>
    </div>
</div>
